import React from 'react';

export const Directions = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.7943 8.78211L11.037 2.02475C10.334 1.32181 9.19434 1.32181 8.4914 2.02475L1.73404 8.78211C1.0311 9.48505 1.0311 10.6247 1.73404 11.3277L8.4914 18.085C9.19434 18.788 10.334 18.788 11.037 18.085L17.7943 11.3277C18.4973 10.6247 18.4973 9.48505 17.7943 8.78211ZM11.8855 1.17623C10.7139 0.00465268 8.81444 0.00465375 7.64287 1.17623L0.885515 7.93358C-0.286058 9.10515 -0.286057 11.0046 0.885516 12.1762L7.64287 18.9336C8.81444 20.1051 10.7139 20.1051 11.8855 18.9336L18.6429 12.1762C19.8144 11.0046 19.8144 9.10515 18.6429 7.93358L11.8855 1.17623ZM10.8255 6.48198C10.8255 5.95937 11.4472 5.68659 11.8317 6.04046L14.1497 8.17344C14.408 8.41112 14.408 8.81879 14.1497 9.05647L11.8317 11.1895C11.4472 11.5434 10.8255 11.2706 10.8255 10.748V9.21502H8.09054C7.64871 9.21502 7.29053 9.5732 7.29053 10.015V12.9823C7.29053 13.3137 7.02191 13.5823 6.69053 13.5823C6.35916 13.5823 6.09053 13.3137 6.09053 12.9823V10.015C6.09053 8.91046 6.98597 8.01502 8.09054 8.01502H10.8255V6.48198Z"
      fill="currentColor"
    />
  </svg>
);
